export default __webpack_public_path__ + "static/media/scdream2.0d22078e.woff";